<template>
    <div class="card">
        <div class="card-body p-0">
            <div
                class="row m-0 w-100 align-items-center padding-l-10 padding-r-10 padding-t-10 justify-content-start filter-block"
            >
                <div
                    v-if="selectedCategory?.value"
                    @click="removeSelectedCategory"
                    class="pointer d-flex align-items-center justify-content-center padding-l-10 padding-t-10"
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M9.2069 10.4194L14.7931 5L16.5 6.65591L10.9138 12.0753L16.5 17.3441L14.7931 19L9.2069 13.7312L7.5 12.0753L9.2069 10.4194Z"
                            fill="#006BE6"
                        />
                    </svg>
                </div>
            </div>
            <div class="row w-100 m-0">
                <div
                    class="col-12 tenders-list padding-b-10 padding-t-10 padding-r-10 padding-l-10"
                >
                    <div class="d-flex flex-wrap gap-2">
                        <template v-if="hasSelectedCategory">
                            <tender-card
                                @click="
                                    $router.push(
                                        `/timeless-tenders/tender/${tender.id}`
                                    )
                                "
                                :tender="tender"
                                :selectedType="selectedType"
                                :can-favorite="true"
                                :can-edit="false"
                                v-for="tender in tenders"
                                :key="tender.id"
                            />
                        </template>
                        <template v-else>
                            <category-card
                                :category="category"
                                :selectedCategory="selectedCategory"
                                @clickMethod="handleSelectCategory"
                                :show-count="true"
                                v-for="(category, index) in timelessTendersCategories.filter(cat => cat.count)"
                                :key="index"
                            />
                        </template>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TenderCard from '@/components/timelessTenders/tenderCard.vue'
import CategoryCard from '@/components/timelessTenders/categoryCard.vue'

export default {
    components: { CategoryCard, TenderCard },
    data() {
        return {
            dateNow: new Date(),
            backendUrl: process.env.VUE_APP_URL,
            tenders: [],
            allTenders: [],
            selectedCategory: {},
            categoryCounts: {},
            hasSelectedCategory: false,
            selectedType: 'all',
            searchQuery: '',
            cpvs: [],
            columns: [
                'password',
                'title',
                'products',
                'opening_finish_date',
                'price',
                'region',
                'type',
                'invitation',
                'edit',
                'participants_count',
            ],
        }
    },
    computed: {
        currentPlan() {
            return this.$store.getters['procurement/currentPlan']
        },
        locale() {
            return this.$store.getters['user/locale']
        },
        timelessTendersCategories() {
            const base = this.$store.getters['settings/timelessTendersCategories'];
            return base.map((category) => ({
                ...category,
                count: this.categoryCounts?.[category.value] || 0
            }));
        },
    },
    mounted() {
        this.getTenders()
    },
    methods: {
        getTenders() {
            this.$client
                .get('timeless-tenders', {
                    params: {
                        favorite: true,
                        type: 'all',
                        category: this.selectedCategory?.value ?? '',
                    },
                })
                .then(({ data }) => {
                    console.log('data', data)
                    if (!this.hasSelectedCategory) {
                        this.allTenders = data.data;
                        this.updateCategoryCounts();
                    } else {
                        this.tenders = data.data;
                    }
                })
                .finally(() => {
                    this.refreshTimelessMenuNotifications();
                });
        },
        updateCategoryCounts() {
            const counts = {};
            this.allTenders.forEach((tender) => {
                const category = tender.category;
                if (category) {
                    counts[category] = (counts[category] || 0) + 1;
                }
            });
            this.categoryCounts = counts;
        },
        handleSelectCategory(category) {
            if(category.count){
                this.selectedCategory = category
                this.hasSelectedCategory = true
                this.getTenders()
            }
        },
        removeSelectedCategory(){
            this.tenders = [];
            this.selectedCategory = {}
            this.hasSelectedCategory = false
        },
        refreshTimelessMenuNotifications() {
            this.$store.dispatch('user/getMenuNotifications')
        },
    },
}
</script>
<style scoped>
.cpv-select-block {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
    .cpv-select-btn {
        height: 36px;
        width: 365px;
        margin: 0 !important;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #2d3036;
        }
    }
}
@media (max-width: 1024px) {
    .cpv-select-block,
    .cpv-search-block {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
    }
    .cpv-select-btn {
        width: 100% !important;
    }
}

@media (max-width: 480px) {
    .filter-block {
        flex-direction: column !important;
    }
    .cpv-select-block,
    .cpv-search-block {
        width: 100% !important;
        padding: 0 !important;
    }
    .cpv-search-block {
        padding: 20px 0 0 0 !important;
    }
}
</style>
